<div class="modal-header">
    <h4 *ngIf="title" class="modal-title">{{title}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body" [innerHTML]="bodyText"></div>
